module.exports = __webpack_public_path__ + "assets/img/operaterule_step3.6daf5c63.png";